import React from "react";
var __jsx = React.createElement;
import { Fragment, useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
import OilBanner from "./components/OilBanner/OilBanner";
import OilHeader from "./components/OilHeader/OilHeader";
import OilProductCard from "./components/OilProductCard/OilProductCard";
import OilGuidanceSteps from "./components/OilGuidanceSteps/OilGuidanceSteps";
import OilServiceCenter from "./components/OilServiceCenter/OilServiceCenter";
import OilInfoList from "./components/OilInfoList/OilInfoList";
import OilCarOffers from "./components/OilCarOffers/OilCarOffers";
import OilFAQ from "./components/OilFAQ/OilFAQ";
import OilStickyBar from "./components/OilStickyBar/OilStickyBar";
import { useCart } from "@/common/Contexts/CartContext";
import { trackEvents } from "@/common/events/events";
import useBFCacheBuster from "@hooks/useBFCacheBuster";
var OilsPage = function OilsPage() {
  var sections = useFullPageData(PageNamesEnum.PAGE_NAME__OilsPage);
  var _useCart = useCart(),
    seedCart = _useCart.seedCart,
    loadCart = _useCart.loadCart;

  // Force reload on browser back so removed cart items don't reappear from bfcache.
  useBFCacheBuster();
  useEffect(function () {
    if (!__IS_CSR__) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get("referral") !== "hero_banner") return;
    trackEvents("vas_listing_viewed", {
      vas_category: "oil",
      referral_location: "hero_banner"
    });
    url.searchParams["delete"]("referral");
    window.history.replaceState(window.history.state, "", url.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (!sections) return;
    var cartBlocks = sections.filter(function (b) {
      return b.component_type === "cart_items" || b.component_type === "cart_summary" || b.component_type === "cart_cta";
    });
    // Seed from the SSR payload for an instant, mostly-correct first paint...
    if (cartBlocks.length > 0) seedCart(cartBlocks);
    // ...then reconcile against the authoritative live cart (/cart/get-cart).
    // The SSR landing-page payload can lag a just-committed quantity change
    // (e.g. edited on the cart page, then "Add More" hard-navigates here), so
    // we always re-fetch the live cart to correct the per-option counts.
    if (__IS_CSR__) loadCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!sections) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    hideHeaderOnmobile: true,
    headHideLinks: true,
    disableLoader: true,
    hideOrangeHeadBtn: true,
    showUserAvatar: true,
    showCartIcon: true
  }, /*#__PURE__*/React.createElement(OilHeader, null), /*#__PURE__*/React.createElement("section", {
    className: "bg-[#F1F6FC] pt-4"
  }, sections.map(function (section, index) {
    var _ref, _section$id;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: (_ref = (_section$id = section.id) !== null && _section$id !== void 0 ? _section$id : section.key) !== null && _ref !== void 0 ? _ref : index
    }, renderOilSection(section));
  })), /*#__PURE__*/React.createElement(OilStickyBar, null));
};
function renderOilSection(section) {
  switch (section.component_type) {
    case "banner":
      return /*#__PURE__*/React.createElement(OilBanner, {
        section: section
      });
    case "oil_listing":
      return /*#__PURE__*/React.createElement(OilProductCard, {
        section: section
      });
    case "text_carousel":
      return /*#__PURE__*/React.createElement(OilGuidanceSteps, {
        section: section
      });
    case "banner_header":
      return /*#__PURE__*/React.createElement(OilServiceCenter, {
        section: section
      });
    case "info_list":
      return /*#__PURE__*/React.createElement(OilInfoList, {
        section: section
      });
    case "posts_list":
      return /*#__PURE__*/React.createElement(OilCarOffers, {
        section: section
      });
    case "faq":
      return /*#__PURE__*/React.createElement(OilFAQ, {
        section: section
      });
    default:
      return null;
  }
}
export default OilsPage;